import "./LocalSeoConsultantNorthampton.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import ConsultantBenefits from "./sections/ConsultantBenefits";
import Sectors from "./sections/Sectors";
import Methodology from "./sections/Methodology";
import Localseogrid from "./sections/Localseogrid";
import Northampton from "./sections/Northampton";
import Heroauthority from "./sections/Heroauthority";
import Northamptonlocalseofaq from "./sections/Northamptonlocalseofaq";
import Northamptonmarketanalysis from "./sections/Northamptonmarketanalysis";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantNorthamptonPage() {
  return <div>
      <Header />
      <Casestudyshowcase />
      <ConsultantBenefits />
      <Sectors />
      <Methodology />
      <Localseogrid />
      <Northampton />
      <Heroauthority />
      <Northamptonlocalseofaq />
      <Northamptonmarketanalysis />
      <Consultation />
      <Footer />
    </div>;
}